console.log(DEPLOYMENT_SETTINGS);
export default DEPLOYMENT_SETTINGS;
